var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C27.165 0 35 7.835 35 17.5S27.165 35 17.5 35 0 27.165 0 17.5 7.835 0 17.5 0z",
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 8.015c-.355-.047-1.58-.14-3.001-.14-2.975 0-5.017 1.597-5.017 4.524v2.522H12.25v3.423h3.357v8.781h4.029v-8.78h3.345l.514-3.424h-3.86v-2.188c0-.983.304-1.665 1.924-1.665h2.066V8.015z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAlt);
export default __webpack_public_path__ + "static/media/facebook-alt.c5c2f30fac05b315ba7fab3b34322488.svg";
export { ForwardRef as ReactComponent };